// 印尼
export default {
    dialog: {
        msgShow: "Pemberitahuan",
        buttonOk: 'OKE',
        buttonCancel: 'Tutup',
    },
    photoBrowser: {
        bannerPhotoBrowser: 'Tutup'
    },
    employeeNumber: 'ID Teknisi',
    pleaseEnterEmployeeNumber: 'Masukkan ID teknisi',
    password: 'Kata sandi',
    pleaseEnterPassword: 'Masukkan kata sandi',
    login: 'Gabung',
    required: 'Diperlukan',
    synchronize: 'Sinkronisasi.',
    salesOrder: 'Laporan servis',
    pleaseEnterHome: 'Masukkan nama pelanggan & laporan servis',
    searchFilter: 'Cari & Filter',
    machineSpecifications: 'Model & Spesifikasi',
    processingStatus: 'Keadaan',
    processing: null,
    finish: 'Selesai',
    waitCountermeasures: null,
    reset: 'Kembali',
    submit: 'Terkirim',
    muMachineInvestigation: 'Pemanfaatan mesin',
    logout: 'Keluar',
    searchDate: 'Tanggal pencarian',
    time: 'Waktu pencarian',
    basicInformation: 'Data pelanggan',
    addSalesOrder: null,
    save: 'Menyimpan',
    date: 'Tanggal',
    pleaseSelectDate: 'Pilih tanggal',
    travelNumber: 'File laporan servis',
    pleaseEnterTravelNumber: 'Masukkan no. file laporan servis',
    customerCode: 'Kode pelanggan',
    pleaseEnterCustomerCode: 'Masukkan kode pelanggan',
    customerName: 'Nama Pelanggan',
    pleaseEnterCustomerName: 'Masukkan nama pelanggan',
    country: 'Nama negara',
    pleaseEnterCountry: 'Masukkan nama negara',
    customerAddress: 'Alamat pelanggan',
    pleaseEnterAddress: 'Masukkan alamat pelanggan',
    customerContact: 'Kontak person pelanggan',
    pleaseEnterContact: 'Masukkan contact person pelanggan',
    salesRepresentative: 'Perwakilan penjualan',
    pleaseEnterSalesRepresentative: 'Silakan masukkan perwakilan penjualan',
    hint: 'Pemberitahuan',
    createDate: 'Tetapkan tanggal',
    salesOrderNumber: 'No. berkas laporan',
    customerSatisfaction: 'Kepuasan pelanggan',
    maintenancePersonnel: 'Teknisi',
    maintenanceTime: 'Waktu servis',
    customerConfirmation: 'Konfirmasi pelanggan',
    copy: 'Menyalin',
    delete: 'Menghapus',
    recordTime: 'Catat waktu',
    machineNumber: 'Nomor Mesin.',
    copyToSalesOrder: 'Salin',
    copyTo: 'Salin ke',
    selectSalesOrderNumber: 'Pilih file laporan servis',
    pleaseEnterSalesOrderNumber: 'Masukkan no. file laporan servis',
    latitudeAndLongitude: 'Garis lintang & garis bujur',
    startMaintenance: 'Mulai servis',
    endMaintenance: 'Selesai servis',
    newMachine: 'Laporan pemasangan',
    maintenance: 'Perbaikan mesin',
    addMachineServiceOrder: null,
    selectType: 'Pilih tipe',
    generalMaintenance: 'Perbaikan mesin',
    oilEducationTraining: 'Pelatihan OIL Pai Lung',
    pleaseEnterMachineNumber: 'Masukkan nomor mesin.',
    manufacturingDate: 'Tanggal produksi',
    pleaseSelectManufacturingDate: 'Pilih tanggal produksi',
    maintenanceWarranty: 'Servis dalam garansi (satu tahun)',
    underWarranty: 'Servis dalam masa garansi',
    warrantyExpired: 'Garansi telah habis',
    confirm: 'OKE',
    cancel: 'Batal',
    addMaintenancePersonnel: 'Masukkan tambahkan nama teknisi',
    maintenanceTimeTotal: 'Total waktu servis',
    day: 'hari',
    hour: 'Jam',
    enterFactory: 'Mulai servis',
    pleaseSelectEnterFactory: 'Pilih mulai servis',
    longitude: 'Garis bujur',
    // pleaseEnterLongitude: 'Silakan masukkan garis lintang',
    latitude: 'Garis Lintang',
    // pleaseEnterLatitude: 'Silakan masukkan garis bujur',
    leaveFactory: 'Servis selesai',
    pleaseSelectLeaveFactory: 'Silahkan pilih servis selesai',
    duration: 'Waktu servis',
    pleaseEnter: 'Silahkan masukkan',
    selectTime: 'Pilih tanggal & jam',
    selectSatisfaction: 'Kepuasan pelanggan',
    verySatisfied: 'Sangat puas',
    satisfied: 'Puas',
    ordinary: 'Biasa',
    dissatisfied: 'Tidak puas',
    veryDissatisfied: 'Sangat tidak puas',
    opinionReply: 'Komentar pelanggan',
    takePhoto: 'Ambil foto',
    uploadFile: 'Unggah data',
    audio: 'berkas audio',
    video: 'Berkas video',
    electronicSignature: 'Tanda tangan pelanggan',
    signatureDate: 'Tanggal tanda tangan',
    clear: 'Menghapus',
    machineInformation: 'Data Mesin',
    machineFunction: 'Pengecekan Mesin',
    organizationArrangement: 'Struktur & Pola',
    spareParts: 'Bagian',
    operationProcedure: 'Catatan tes',
    problemHandling: 'Proses',
    trainee: 'peserta pelatihan',
    coursePlan: 'Rencana pelatihan',
    courseSchedule: 'Jadwal pelatihan',
    inputVoltageAndCurrent: 'Masukkan tegangan/ampere',
    lowSpeed: 'Kecepatan lambat',
    highSpeed: 'Kecepatan tinggi',
    accelerationDecelerationSlope: 'MEMPERCEPAT / MEMPERLAMBAT lereng',
    acceleration: null,
    deceleration: null,
    clothRoller: 'Take up',
    left: 'Kiri',
    center: 'Tengah',
    right: 'Kanan',
    yarnFeedingTeeth: 'gigi erotip/pully',
    saddleRingDistance: 'Jarak cam holder ring & rangka',
    yarnNozzleNumber: 'Feeder',
    height: 'Tinggi',
    spacing: 'Jarak',
    warpYarnInfo: 'Kain grey',
    inch: 'Inci',
    cm: 'Sentimeter',
    timeSequence: 'Waktu',
    needle: 'jarum',
    yarnSpecification: 'Spesifikasi benang',
    yarn: 'Benang',
    serialNumber: 'No. mesin lainnya',
    technician: 'Teknisi',
    series: 'Seri kain',
    fabricType: 'Jenis kain',
    productFeatures: 'Fitur Produk',
    inputVoltage: 'Masukkan tegangan',
    inputCurrent: 'Masukkan ampere',
    electronicWindingTensionUpper: 'Ampere rol elektronik (atas)',
    electronicWindingTensionLower: 'Ampere rol elektronik (bawah)',
    mechanicalType: 'Gigi rol mekanik',
    lowerNeedleDistanceToSeatRing: 'Jarak silinder & cam holder ring',
    upperNeedleDistanceToSeatRing: 'Jarak dial & cam holder ring',
    upperNeedleDistanceToLowerNeedleNozzle: 'Dial celah & silinder terbentur tepinya',
    selectorNeedleRingDistanceToTakeUpPlate: 'Jarak ring actuator & rangka',
    seatRingDistanceToTakeUpPlate: 'Jarak cam holder ring & rangka',
    machineSpeed: 'kecepatan',
    inverterFrequency: null,
    yarnCount: 'Mata arah horizontal',
    gramsPerSquareMeter: 'GSM',
    yardsPerPound: 'G/YD',
    customerYarnWidth: 'Lebar',
    customerSpecifiedYarnLength: 'Panjang jahitan ditentukan',
    newCustomerPackageTiming: 'Waktu pemberat',
    doubleSidedCuttingTiming: 'Pengaturan waktu kamera panggilan',
    nozzleTiming: 'Waktu pembawa benang',
    yarnCode: 'Kode benang',
    yarnType: 'Spesifikasi Benang.',
    color: 'Warna',
    yarnSize: 'Jumlah benang',
    fiberCount: 'Filamen',
    innerFiber: 'Tumpuk masuk',
    outerFiber: 'Tumpuk',
    flatness: 'Kerataan',
    roundness: 'Kebulatan',
    windPressure: 'Tekanan angin',
    appearance: 'Penampilan',
    machineLevel: 'Kerataan rangka mesin',
    trident: 'Tingkat kerataan & kebulatan dial',
    highLegWinder: 'Take up high leg',
    fabricSlitting: 'Take up open width',
    inverterCurrent: 'Ampere inverter',
    machineFunctionFrame: 'Benang MPF & Cincin & Creel',
    inchStart: 'Fungsi tombol jog, start dan stop',
    firstSecondSpeed: 'Fungsi tombol kecepatan, lampu dan kipas',
    firstSecondSpeed2: 'Fungsi pengaturan kecepatan.',
    controllerOtherFunctions: 'Fungsi lain controller',
    electricalBoxSignals: 'Sinyal & Sensor',
    fanDustRemovalAction: 'Operasional kipas',
    oilSprayerAction: 'Operasional pompa oli',
    airBlowerSystemAction: 'Operasional & tekanan angin',
    windingAction: 'Operasional take up',
    machineControllerOperationTutorial: 'Pelatihan operasional control panel',
    machineOperationTutorial: 'Pelatihan pengoperasian M/C',
    other: 'Yang lain',
    descriptionAndAttachment: 'Referensi',
    upperNeedleArrangement: 'Urutan jarum dial',
    upperKnifeArrangement: 'Urutan pisau dial',
    lowerNeedleArrangement: 'Urutan jarum silinder',
    lowerNeedleArrangementShort: 'Urutan jarum…',
    lowerKnifeArrangement: 'Urutan pisau silinder',
    lowerKnifeArrangementShort: 'Urutan pisau…',
    upperNeedlePlate: 'Dial',
    lowerNeedleCylinder: 'Silinder',
    blank: 'Ruang',
    blockRule: 'Ukur jig',
    retractionBaseline: 'Jarak sinker belakang',
    upperPlateNeedleWithdrawalKnob: 'Kenop skala dial',
    upperPlateNeedleWithdrawalDepth: 'Jarak dial stitch',
    upperPlateHalfNeedleHeight: 'Jarak knit dial, cam tuck',
    upperPlateFlatNeedleHeight: 'Jarak cam miss dial',
    lowerCylinderFlatNeedleHeight: 'Jarak cam miss silinder',
    lowerCylinderFlatNeedleDepth: 'Jarak stitch silinder',
    lowerCylinderNeedleWithdrawalKnob: 'Kenop skala silinder',
    yarnTypeCode: 'Kode benang',
    yarnTypeTensionN: 'Ketegangan benang (N)',
    cmPer100Needles: 'Panjang jahitan / 100N',
    feedYarnLengthPerRevolution: 'Panjang jahitan / 1 Kursus',
    aluminumPlateYarnFeedingDepthCm: 'Diameter pully erotip (cm)',
    yarnFeedingAluminumPlateScale: 'Tanda pully erotip',
    newCustomerPackage: 'Sinker',
    upperPlate: 'Dial',
    lowerCylinder: 'Silinder',
    yarnShort: 'Benang',
    pleaseEnterProductName: 'Masukkan deskripsi barang',
    pleaseEnterProductNumber: 'Masukkan no. barang',
    quantity: null,
    damage: 'Rusak',
    missing: 'Hilang',
    wrong: 'Salah',
    pleaseEnterTitle: 'Masukkan judul',
    pleaseEnterContent: 'Masukkan konten',
    addQuestionItem: 'Tambahkan item pertanyaan',
    questionProcessingRecord: 'Catatan penanggulangan',
    pleaseEnterQuestionDescription: 'Masukkan deskripsi masalah',
    traineeAndClient: null,
    trainer: 'Pelatih',
    drawingFunction: 'Fungsi CAD',
    upperMachineProgram: 'Program mesin',
    UnravelingFunction: 'Analisis kain',
    courseName: 'Masukkan nama pelatihan',
    pleaseEnterCourseName: 'Masukkan nama pelatihan',
    imageName: 'Nama file pola',
    pleaseEnterImageName: 'Masukkan nama file pola',
    confirmItem: 'Mengonfirmasi',
    undone: 'Tidak lengkap',
    pleaseEnterInquire: 'Masukkan Nama Pelanggan, dokumen MU',
    machineUtilizationSurvey: 'Pemanfaatan mesin',
    customerID: 'ID Pelanggan',
    pleaseEnterCustomerID: 'Masukkan ID pelanggan',
    pleaseSelect: 'Pilih',
    pleaseEnterSkill: 'Masukkan keterampilan',
    pleaseEnterBuyer: 'Masukkan pembeli',
    pleaseEnterRemark: 'Masukkan komentar',
    source: 'Sumber',
    selfInput: '自行輸入',
    textileEquipment: 'Mesin rajut',
    textileMachineBrand: 'Merk mesin rajut',
    textileMachineType: 'Model mesin rajut',
    notSelected: 'Pilih belum',
    select: 'Pilih',
    brand: 'Merk',
    totalMachine: null,
    openRate: null,
    dailyOutput: null,
    spinning: '紡紗',
    knitting: '針織',
    dyeing: '染整',
    garment: '成衣',
    pleaseEnterProcessingContent: 'Silakan masukkan konten penyesuaian.',
    // alert
    editNotSave: 'Hasil editnya belum disimpan. Apakah Anda yakin untuk keluar?',
    deleteConfirm: 'Apakah Anda yakin akan menghapusnya?',
    confirmClearSignature: 'Apakah Anda yakin akan menghapus data terkait tanda tangan?',
    confirmWriteData: 'Apakah Anda yakin untuk menulis di data?',
    confirmCopyToSalesOrder: 'Apakah Anda yakin akan menyalin data ke laporan servis ini?',
    fieldsNotFilledUnableToSend: '尚有欄位未填寫，無法送出。',
    dataWriteComplete: '資料寫入完成。',
    deleteSuccess: 'Penghapusan berhasil.',
    clearSuccess: 'Hapus berhasil.',
    copySuccess: 'Salin berhasil.',
    selectWorker: 'Silakan pilih teknisi.',
    selectProblem: 'Silakan pilih item pertanyaan.',
    unknownError: 'An unknown error has occurred, please contact customer service.',
    fileTypeError: 'File type mismatch',
    openCameraPermission: 'Please grant camera access first.',
    //new
    selectDate: 'Pilih tanggal',
    yarnTensionN: 'Ketegangan benang (N)',
    category: 'Jenis',
    kind: 'Model',
    // pleaseSelectType: 'Pilih tipe',
    dateInOutError: 'Tanggal selesai servis harus selalu sama dengan atau lebih lambat dari tanggal mulai servis.',
    yarnFeedingTeethOrDisc: 'gigi erotip/pully',
    changed: 'Berubah',
    pleaseSelectSparePartsStatus: 'Silakan pilih status aksesori.',
    pleaseEnterDuration: null,

    // API語系
    saveComplete: 'Simpan berhasil.',
    needOnline: 'Need Online.',
    addComplete: 'Tambahkan berhasil.',
    reportCreator: 'Pembuat Laporan',
    onlineGenerate: 'Generate after uploading',
    synchronizeFail: '同步異常',
    synchronizeSuccess: 'Sinkronisasi berhasil.',
    downloadFail: '下載異常',
    downloadSuccess: 'Pengunduhan berhasil.',
    synchronizeSelect: 'Sinkronkan Pilihan',
    onlySynchronizeOffData: 'Mengunduh data daring',
    synchronizeData: 'Menyinkronkan data offline',
    synchronizeImage: 'Sinkronkan Gambar',
    downloadOfflineFile: 'Download OffLine File',
    downloadOfflineData: 'Unduh Data Offline',
    downloadOfflineImage: 'Unduh Gambar Offline',
    synchronizing: 'Sedang menyinkronkan, harap tunggu. Jangan tutup layar aplikasi.',
    downloading: 'Sedang mengunduh, harap tunggu. Jangan tutup layar aplikasi.',
    confirmDownload: 'Apakah Anda mengonfirmasi pengunduhan?',
    confirmSynchronization: 'Apakah Anda mengonfirmasi sinkronisasi?',
    overwriteOffline : 'Pengunduhan akan menimpa data offline saat ini.',
    synchronizationOnline: 'Sinkronisasi akan menyinkronkan data online terkait.',
    uploadFail: '上傳異常',
    fileSzieOverTit: 'The file size is too large.',
    fileSzieOverMes: 'Only files under 50 MB can be uploaded. For files over 50 MB, please upload to the wired version.',

    sortByCreate: 'Susun berdasarkan pembuatan',
    sortByType: 'Susun berdasarkan jenis',
    reportDownload: 'laporan',
    selectServiceReport: 'Pilih Laporan Layanan',
    enterServiceReportOrMachine: 'Masukkan no. laporan layanan atau no. mesin',
    selectAll: 'Pilih semua',

    downloadHint:null
}
